import { useEffect, useState } from 'react'
import debounce from 'lodash/debounce'
import TextAreaField from 'components/ui/TextAreaField'
import Button from 'components/ui/Button'
import { useCartUpdateCustomerNotes } from 'components/pages/CartPage/CustomerNotes/types/cartUpdateCustomerNotes'

type Props = {
  cartRefetch: () => void
  uuid: string
  defaultCustomerNotes?: string
}

const callUpdateWithDebounce = debounce((func) => func(), 2000)

const CustomerNotes = ({
  uuid,
  cartRefetch,
  defaultCustomerNotes = ''
}: Props) => {
  const [cartUpdateCustomerNotes] = useCartUpdateCustomerNotes({})

  const [customerNotes, setCustomerNotes] = useState<string>('')
  const [addNotes, setAddNotes] = useState<boolean>(false)

  const cartCustomerNotes = defaultCustomerNotes
  useEffect(() => {
    setCustomerNotes(cartCustomerNotes)
  }, [cartCustomerNotes])

  const updateCustomerNotes = async ({ notes }: { notes: string }) => {
    const response = await cartUpdateCustomerNotes({
      notifications: {
        onError: true
      },
      variables: {
        cartUuid: uuid,
        customerNotes: notes
      }
    })
    if (!response) return

    await cartRefetch()
  }

  const onChangeNotes = (notes: string) => {
    setCustomerNotes(notes)
    setAddNotes(true)
    callUpdateWithDebounce(() => updateCustomerNotes({ notes }))
  }

  const notesVisible = addNotes || customerNotes.length > 0

  return (
    <div>
      {notesVisible ? (
        <>
          <div className="block text-sm font-medium text-gray-800">
            Notes / special requests
          </div>
          <TextAreaField
            onChange={(e) => onChangeNotes(e.target.value)}
            rows={2}
            value={customerNotes}
          />
        </>
      ) : (
        <Button
          color="default"
          onClick={() => setAddNotes(true)}
          size="small"
          variant="anchor"
        >
          Add notes / special requests
        </Button>
      )}
    </div>
  )
}

export default CustomerNotes
